// The slices written to localStorage, keyed by slice name. The value is the
// replacer applied to the slice before it is stored: an object of keys that
// override the live value, or a function that returns the value to store.
//
// rootReducer wraps each of these slices with statePersistanceWrapper, and the
// logout reset reduces each to the same stored form. A reload and a logout
// therefore leave the same data behind.
export const persistedSliceReplacers = {
  interactableState: {
    uiDesignMode: null
  },
  appConfig: {
    printers: null,
    patientSearchHistory: null,
    users: [],
    lobbyKioskExitPin: null,
    headerStyleOverride: null
  },
  clock: {}
}
